import { h, ComponentChildren } from "preact";

import CSSProperties from "../../../../foundation/model/CSSProperties";
import classname from "../../../../foundation/utils/classname";
import IconClose from "../../Icons/IconClose";
import PlaceholderBlock from "../../PlaceholderBlock";

import {
    BARREL_CARD_WIDTH,
    BARREL_CARD_HEIGHT,
    BARREL_CARD_THUMBNAIL_WIDTH,
    BARREL_CARD_THUMBNAIL_HEIGHT
} from "../specs";

import styles from "./BarrelCardPlaceholder.module.css";

interface Props {
    class?: string;
    thumbnailContent?: ComponentChildren;
    showCloseButton?: boolean;
    onCloseButtonClick?: (ev: Event) => void;
}

function BarrelCardPlaceholder({
    class: cssClass,
    thumbnailContent,
    showCloseButton = false,
    onCloseButtonClick
}: Props) {
    const style = {
        "--barrel-card-width": `${BARREL_CARD_WIDTH}px`,
        "--barrel-card-height": `${BARREL_CARD_HEIGHT}px`,
        "--barrel-card-thumbnail-width": `${BARREL_CARD_THUMBNAIL_WIDTH}px`,
        "--barrel-card-thumbnail-height": `${BARREL_CARD_THUMBNAIL_HEIGHT}px`
    } as CSSProperties;

    return (
        <div
            class={classname(styles.barrelCardPlaceholder, cssClass)}
            style={style}>
            <PlaceholderBlock class={styles.thumbnail}>
                {thumbnailContent}
                {showCloseButton && (
                    <div class={styles.closeButton} onClick={onCloseButtonClick}>
                        <IconClose color="var(--label-tertiary)"/>
                    </div>
                )}
            </PlaceholderBlock>
            <div class={styles.info}>
                <PlaceholderBlock class={styles.name}/>
                <PlaceholderBlock class={styles.date}/>
            </div>
        </div>
    );
}

export default BarrelCardPlaceholder;
